import React from 'react';
import { Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { Button, Typography } from '@occc-app/design-system';

export type LoginRequestedConfigurationProps = {
  onGoBackClick: () => void;
};

export const LoginRequested = ({ onGoBackClick }: LoginRequestedConfigurationProps) => {
  return (
    <Box>
      <Typography variant='subtitle1' component='h2' paragraph data-testid='checkEmail'>
        Check your email
      </Typography>

      <Typography gutterBottom>
        If that email is registered, you will receive a login link shortly.
      </Typography>

      <Button onClick={onGoBackClick} color='primary' startIcon={<ArrowBack />}>
        Back to Log in
      </Button>
    </Box>
  );
};
